import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["modal"]

  connect() {
    this.postContent = this.element.dataset.postContent
    this.postTitle = this.element.dataset.postTitle
  }

  openModal() {
    this.modalTarget.classList.remove("hidden")
    this.modalTarget.classList.add("flex")
  }

  closeModal() {
    this.modalTarget.classList.add("hidden")
    this.modalTarget.classList.remove("flex")
  }

  copyForLLM(event) {
    const text = `Title: ${this.postTitle}\n\nContent:\n${this.postContent}`
    const button = event.currentTarget
    const originalText = button.innerHTML

    navigator.clipboard.writeText(text).then(() => {
      button.innerHTML = `<svg class="w-3 h-3" fill="none" stroke="currentColor" viewBox="0 0 24 24"><path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M5 13l4 4L19 7"></path></svg> Copied`
      setTimeout(() => {
        button.innerHTML = originalText
      }, 2000)
    }).catch(() => {
      this.showToast("Failed to copy", "error")
    })
  }

  askChatGPT() {
    const prompt = this.buildPrompt()
    const url = `https://chat.openai.com/?q=${encodeURIComponent(prompt)}`
    window.open(url, "_blank")
    this.closeModal()
  }

  askGemini() {
    const prompt = this.buildPrompt()
    const url = `https://gemini.google.com/app?q=${encodeURIComponent(prompt)}`
    window.open(url, "_blank")
    this.closeModal()
  }

  askClaude() {
    const prompt = this.buildPrompt()
    const url = `https://claude.ai/new?q=${encodeURIComponent(prompt)}`
    window.open(url, "_blank")
    this.closeModal()
  }

  buildPrompt() {
    return `Please analyze the following blog post and provide insights, suggestions for improvement, and any questions you have about the content:\n\nTitle: ${this.postTitle}\n\n${this.postContent}`
  }

  showToast(message, type = "success") {
    const toast = document.createElement("div")
    toast.className = `fixed bottom-4 right-4 px-4 py-2 rounded-lg text-sm font-medium ${type === "success" ? "bg-green-600 text-white" : "bg-red-600 text-white"} z-50`
    toast.textContent = message
    document.body.appendChild(toast)
    setTimeout(() => toast.remove(), 3000)
  }
}
